import { createSlice } from "@reduxjs/toolkit";
import { searchPharmacyMedicinesAndCosmetics } from "../../reducer/searchPharmacyMedicinesAndCosmetics/searchPharmacyMedicinesAndCosmeticsReducer";

const initialState = {
  data: null,
  isLoading: false,
  error: null,
};

const searchPharmacyMedicinesAndCosmeticsSlice = createSlice({
  name: "searchPharmacyMedicinesAndCosmetics",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(searchPharmacyMedicinesAndCosmetics.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(
        searchPharmacyMedicinesAndCosmetics.fulfilled,
        (state, action) => {
          state.isLoading = false;
          state.data = action.payload;
        },
      )
      .addCase(
        searchPharmacyMedicinesAndCosmetics.rejected,
        (state, action) => {
          state.isLoading = false;
          state.error = action.payload || action.error.message;
        },
      );
  },
});

export default searchPharmacyMedicinesAndCosmeticsSlice.reducer;
